import { render } from "./selectYearAcessStatus.vue?vue&type=template&id=1770f3cc"
import script from "./selectYearAcessStatus.vue?vue&type=script&lang=js"
export * from "./selectYearAcessStatus.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__